var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIntervention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_10703",
    "data-name": "Grupo 10703",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.386,
    height: 82.36,
    viewBox: "0 0 82.386 82.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4083",
    "data-name": "Trazado 4083",
    d: "M-307.871,543.329a13.032,13.032,0,0,0-13.015,13.015,13.032,13.032,0,0,0,13.015,13.015,13.033,13.033,0,0,0,13.021-13.015A13.034,13.034,0,0,0-307.871,543.329Z",
    transform: "translate(349.05 -487)",
    fill: "#fc7804"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4084",
    "data-name": "Trazado 4084",
    d: "M-302.548,543.329a13.033,13.033,0,0,0-13.015,13.015,13.032,13.032,0,0,0,13.015,13.015,13.033,13.033,0,0,0,13.021-13.015A13.034,13.034,0,0,0-302.548,543.329Z",
    transform: "translate(371.913 -487)",
    fill: "#fc7804"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4085",
    "data-name": "Trazado 4085",
    d: "M-313.19,543.329A13.032,13.032,0,0,0-326.2,556.344,13.032,13.032,0,0,0-313.19,569.36a13.034,13.034,0,0,0,13.021-13.015A13.034,13.034,0,0,0-313.19,543.329Z",
    transform: "translate(326.205 -487)",
    fill: "#fc7804"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4086",
    "data-name": "Trazado 4086",
    d: "M-307.871,538.073a13.032,13.032,0,0,0-13.015,13.015A13.029,13.029,0,0,0-307.871,564.1a13.03,13.03,0,0,0,13.021-13.015A13.034,13.034,0,0,0-307.871,538.073Z",
    transform: "translate(349.05 -509.575)",
    fill: "#fc7804"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4087",
    "data-name": "Trazado 4087",
    d: "M-302.548,564.1a13.03,13.03,0,0,0,13.021-13.015,13.034,13.034,0,0,0-13.021-13.015,13.033,13.033,0,0,0-13.015,13.015A13.029,13.029,0,0,0-302.548,564.1Z",
    transform: "translate(371.913 -509.575)",
    fill: "#fc7804"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4088",
    "data-name": "Trazado 4088",
    d: "M-313.19,538.073A13.032,13.032,0,0,0-326.2,551.088,13.029,13.029,0,0,0-313.19,564.1a13.03,13.03,0,0,0,13.021-13.015A13.034,13.034,0,0,0-313.19,538.073Z",
    transform: "translate(326.205 -509.575)",
    fill: "#fc7804"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4089",
    "data-name": "Trazado 4089",
    d: "M-307.871,532.691a13.032,13.032,0,0,0-13.015,13.015,13.032,13.032,0,0,0,13.015,13.015,13.033,13.033,0,0,0,13.021-13.015A13.034,13.034,0,0,0-307.871,532.691Z",
    transform: "translate(349.05 -532.691)",
    fill: "#fc7804"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntervention);
export default __webpack_public_path__ + "static/media/icon-intervention.93ca46366677a3ff1023ee791eeb8f48.svg";
export { ForwardRef as ReactComponent };